{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowSeIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowSeIcon = React.forwardRef<SVGSVGElement, ArrowSeIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 110 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M51.454 45.6281C38.6257 33.0059 25.7914 20.3897 12.9512 7.77973C10.3863 5.27186 7.64747 2.93068 4.87313 0.65319C4.41031 0.280487 3.84581 0.056028 3.25343 0.00919047C2.66106 -0.0376471 2.0683 0.0952988 1.55266 0.390639C0.695483 0.83301 0.4953 2.47587 1.22449 3.47547C1.92809 4.44226 2.55616 5.47664 3.34573 6.36794C8.38378 12.0538 13.2841 17.8755 18.5545 23.3388C29.384 34.5622 40.362 45.6432 51.3779 56.6808C61.8295 67.156 72.4227 77.4867 82.911 87.9278C84.5945 89.6041 86.0613 91.4969 87.5912 93.3235C87.6751 93.4623 87.7229 93.62 87.73 93.782C87.7371 93.944 87.7033 94.1052 87.6319 94.2509C87.4029 94.5397 86.8936 94.9007 86.6245 94.8212C81.6606 93.3537 76.6482 92.0167 71.7795 90.2702C60.4597 86.2075 48.7945 83.4443 37.1196 80.6962C35.2011 80.2453 33.2144 79.7484 31.2782 80.727C30.9264 80.9049 30.3369 81.2233 30.3593 81.4222C30.386 82.1866 30.6016 82.9325 30.9868 83.5933C31.4781 84.2159 32.1325 84.69 32.8771 84.963C35.4952 85.9475 38.1349 86.8855 40.8036 87.723C59.8729 93.7101 78.9605 99.6374 98.0212 105.651C105.211 107.92 109.843 107.783 109.573 96.6984C109.495 93.5046 109.398 90.2932 109.007 87.127C107.194 72.4438 105.312 57.7694 103.362 43.1038C103.039 41.142 102.564 39.2085 101.939 37.3209C101.565 36.0574 100.481 35.5014 99.2406 35.3268C97.8754 35.1352 95.6853 36.3593 95.2035 37.3779C94.1337 39.6403 94.0989 42.051 94.2682 44.4335C94.9193 53.6072 95.6532 62.7749 96.3922 71.942C96.8739 77.9146 97.4306 83.8775 97.9018 89.8495C97.9248 90.1442 97.5079 90.5748 97.1936 90.7618C97.0414 90.8291 96.8752 90.8582 96.7093 90.8468C96.5434 90.8353 96.3827 90.7837 96.2412 90.6962C94.4468 89.121 92.6196 87.5773 90.9433 85.8833C77.722 72.5224 64.5184 59.1436 51.3326 45.7468L51.454 45.6281Z" fill={color}/>

      </svg>
    )
  }
)

ArrowSeIcon.displayName = 'ArrowSeIcon'
